import React from "react";

const HeartIcon = ({ color = "#000000", size = "20" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 23 22"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8023 0.711111C16.511 0.711111 17.2186 0.807585 17.8914 1.02547C22.0371 2.32625 23.5309 6.71638 22.2831 10.5537C21.5755 12.5146 20.4186 14.3043 18.9034 15.7666C16.7345 17.7936 14.3545 19.593 11.7925 21.1431L11.5117 21.3068L11.2197 21.1323C8.64868 19.593 6.25517 17.7936 4.06608 15.7557C2.561 14.2934 1.403 12.5146 0.684156 10.5537C-0.585047 6.71638 0.908794 2.32625 5.09941 1.0027C5.42513 0.894304 5.76097 0.818425 6.09792 0.77615H6.23271C6.54832 0.731706 6.86169 0.711111 7.17618 0.711111H7.29974C8.00734 0.731706 8.69249 0.850945 9.35629 1.06883H9.42256C9.46749 1.08942 9.50118 1.11218 9.52365 1.13278C9.77187 1.20974 10.0066 1.29646 10.2313 1.4157L10.6581 1.59998C10.7612 1.65306 10.877 1.73418 10.977 1.80428C11.0404 1.84869 11.0975 1.88869 11.141 1.91433C11.1594 1.92477 11.178 1.93526 11.1968 1.94585C11.2931 2.0001 11.3934 2.05662 11.478 2.11921C12.7259 1.1989 14.241 0.700271 15.8023 0.711111ZM18.79 8.5158C19.2505 8.50387 19.6436 8.14724 19.6773 7.69089V7.56189C19.711 6.04323 18.7574 4.66765 17.3073 4.1365C16.8468 3.98366 16.3414 4.22322 16.1729 4.67849C16.0157 5.13377 16.2628 5.6324 16.7345 5.79391C17.4545 6.05407 17.9363 6.73806 17.9363 7.49577V7.52937C17.915 7.7776 17.9925 8.01717 18.1497 8.20144C18.307 8.38572 18.5429 8.49303 18.79 8.5158Z"
        fill="#5B93FF"
      />
    </svg>
  );
};

export default HeartIcon;
